import Vue from 'vue'
import Router from 'vue-router'
// import videoTable from './home/videoTable'
import bigData from './home/productAndService/bigData/index'
import graduateSchool from './home/productAndService/bigData/graduateSchool'
import collegeInfo from './aboutUs/collegeInfo/collegeInfo'
import partners from './aboutUs/partners/partners'
import serviceSupport from './aboutUs/serviceSupport/serviceSupport'
import enterpriseRecruitment from './enterpriseRecruitment/enterpriseRecruitment'
import recruitmentDetails from './enterpriseRecruitment/recruitmentDetails'
import news from './news/index.vue'
import customerCase from './aboutUs/customerCase'
import contactUs from './aboutUs/contactUs'
import qualificationHonor from './aboutUs/qualificationHonor'
import developmentHistory from './aboutUs/developmentHistory'
import aboutBw from './aboutUs/aboutBw'

Vue.use(Router)

export default [
  {
    path: '/big-data-service',
    name: 'bigData',
    component: bigData
  },
  {
    path: '/graduate-school',
    name: 'graduateSchool',
    component: graduateSchool
  },
  {
    path: '/college-info',
    name: 'collegeInfo',
    component: collegeInfo
  },
  {
    path: '/partners',
    name: 'partners',
    component: partners
  },
  {
    path: '/service-support',
    name: 'serviceSupport',
    component: serviceSupport
  },
  {
    path: '/enterprise-recruitment',
    name: 'enterpriseRecruitment',
    component: enterpriseRecruitment
  },
  {
    path: '/recruitment-details',
    name: 'recruitmentDetails',
    component: recruitmentDetails
  },
  {
    path: '/news',
    name: 'news',
    component: news
  },
  {
    path: '/customer-case',
    name: 'customerCase',
    component: customerCase
  },
  {
    path: '/contact-us',
    name: 'contactUs',
    component: contactUs
  },
  {
    path: '/qualification-honor',
    name: 'qualificationHonor',
    component: qualificationHonor
  },
  {
    path: '/development-history',
    name: 'developmentHistory',
    component: developmentHistory
  },
  {
    path: '/about-bw',
    name: 'aboutBw',
    component: aboutBw
  }
]



// WEBPACK FOOTER //
// ./src/pages/page-routers.js